import { PureComponent } from 'react'
import _ from 'lodash'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { I13nDiv } from '@vzmi/ec-react-i13n'

import OperatingDashboard, { NoPermissionOperatingDashboard } from './OperatingDashboard'
import styles from './Dashboard.css'
import Main from '../../containers/Main'
import HorizontalLayout from '../../containers/HorizontalLayout'
import { privilegedPagesProtected } from '../../lib/authWrapper'
import dashboardRoutes from '../../../../conf/dashboardConf'

const HelmetSetting = () => (
  <Helmet>
    <title>運籌中心</title>
  </Helmet>
)

export const DASHBOARD_COMPONENT_MAP = {
  dashboard: privilegedPagesProtected({
    Component: OperatingDashboard,
    FailureComponent: NoPermissionOperatingDashboard,
    opts: { isHashNeeded: true }
  })
}

class Dashboard extends PureComponent {
  render () {
    const props = this.props
    const { i13nData, location } = props
    // 如果比對 hash 是以前 dashboard 的 route 就直接 redirect 到新的 route
    const matchedOldRoute = _.find(
      dashboardRoutes,
      { path: `/${_.replace(location.hash, '#', '')}` }
    )
    let LayoutComponent = Main
    if (location.pathname === '/dashboard') {
      LayoutComponent = HorizontalLayout
    }
    return (
      <LayoutComponent
        routes={dashboardRoutes}
        render={(mainProps) => {
          return (
            <I13nDiv
              className={styles.dashboard}
              i13nModel={{ category: _.get(i13nData, 'documentGroup'), action: _.get(i13nData, 'subType') }}
            >
              <HelmetSetting />
              <div className='pure-g'>
                <div className={'pure-u-1'}>
                  <Switch>
                    {
                      !_.isEmpty(matchedOldRoute) && (
                        <Redirect
                          to={matchedOldRoute.path}
                        />
                      )}
                    {
                      dashboardRoutes.map(route => {
                        const {
                          pageKey,
                          ...routeConfig
                        } = route
                        const Component = DASHBOARD_COMPONENT_MAP[pageKey]
                        return (
                          <Route
                            key={pageKey}
                            {...routeConfig}
                          >
                            <Component
                              {...mainProps}
                              {...props}
                            />
                          </Route>
                        )
                      })
                    }
                  </Switch>
                </div>
              </div>
            </I13nDiv>
          )
        }}
        withSubSideBar
      />
    )
  }
}

export default Dashboard
